export class CanvasLayer {
    private _canvas: HTMLCanvasElement;
    private _ctx: CanvasRenderingContext2D;
    private _container: HTMLElement;

    constructor(containerDom: HTMLElement, width: number, height: number) {
        this._container = containerDom;

        // 创建canvas元素
        this._canvas = document.createElement('canvas');
        this._canvas.width = width;
        this._canvas.height = height;

        // 设置样式
        this._canvas.style.position = 'absolute';
        this._canvas.style.left = '0';
        this._canvas.style.top = '0';
        this._canvas.style.zIndex = '0';  // 放在底层
        this._canvas.style.pointerEvents = 'none';  // 不拦截鼠标事件

        // 获取绘图上下文
        const ctx = this._canvas.getContext('2d');
        if (!ctx) {
            throw new Error('无法获取Canvas上下文');
        }
        this._ctx = ctx;

        // 添加到容器
        this._container.insertBefore(this._canvas, this._container.firstChild);
    }

    // 获取绘图上下文
    get context(): CanvasRenderingContext2D {
        return this._ctx;
    }

    // 获取canvas元素
    get element(): HTMLCanvasElement {
        return this._canvas;
    }

    // 调整大小
    resize(width: number, height: number, redrawCallback?: () => void): void {
        this._canvas.width = width;
        this._canvas.height = height;

        // 重新绘制内容
        if (redrawCallback) {
            redrawCallback();
        }
    }

    // 清除内容
    clear(): void {
        this._ctx.clearRect(0, 0, this._canvas.width, this._canvas.height);
    }

    // 销毁
    dispose(): void {
        if (this._canvas.parentNode) {
            this._canvas.parentNode.removeChild(this._canvas);
        }
    }
}